import React, { Suspense, lazy } from "react";
import { Redirect, Route, useHistory } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from "./components/Navbar";
import SocialIcons from "./components/SocialIcons";
import ScrollToTop from "./components/ScrollToTop.js"
import Spinner from "./components/Spinner";
import AdminPage from "./components/pages/admin/AdminPage";
import ProtectedRoute from "./components/ProtectedRoute";
import VerifyPage from "./components/pages/verify/VerifyPage";
import { useState } from "react";
import { useEffect } from "react";
import useEventListener from './hooks/useEventListener';
import DarkmodeButton from "./components/DarkmodeButton";


const HomePage = lazy(() => import('./components/pages/homePage/HomePage'));
const About = lazy(() => import('./components/pages/aboutPage/About'));
const Contact = lazy(() => import('./components/pages/contactPage/Contact'));
const Blog = lazy(() => import('./components/pages/blogPage/Blog'));
const Works = lazy(() => import('./components/pages/workPage/Works.jsx'));


const HIDDEN_KEYS = ['39', '>'];

function App() {
  const [admin, setAdmin] = useState(false);
  const [resumeURI, setResumeURI] = useState('');
  let history = useHistory();

  // get resume
  useEffect(() => {
    const getRequestOptions = {
      method: 'GET',
    };
    fetch(process.env.REACT_APP_API_URI, getRequestOptions)
      .then(response => response.json())
      .then(data => {
        setResumeURI(data?.url);
      })
      .catch(error => {
        console.log(error);
      });

  }, [])
  // end

  function getItemFromLocalStorage() {
    const items = JSON.parse(localStorage.getItem('admin'));
    if (items) {
      setAdmin(items?.admin);
    }
    else {
      setAdmin(null)
    }
  }

  useEffect(() => {
    getItemFromLocalStorage();
    window.addEventListener('storage', getItemFromLocalStorage);
    return () => {
      window.removeEventListener("storage", getItemFromLocalStorage);
    }
  }, []);


  function hiddenKeyHandler({ key }) {
    if (HIDDEN_KEYS.includes(String(key))) {
      history.push("/admin");
    }
  }
  useEventListener('keydown', hiddenKeyHandler);

  return (
    <div>
      <Navbar resumeURI={resumeURI} />
      <Suspense fallback={<Spinner />}>
        <main>
          <ScrollToTop />
          <Route path="/" exact>
            <HomePage resumeURI={resumeURI} />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/work">
            <Works />
          </Route>
          <Route path="/blog">
            <Blog />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/verify">
            {!admin ?
              <VerifyPage />
              :
              <Redirect
                to={{
                  pathname: "/admin",
                }}
              />
            }
          </Route>
          <ProtectedRoute admin={admin} path="/admin">
            <AdminPage />
          </ProtectedRoute>
        </main>
      </Suspense>
      <DarkmodeButton />
      <SocialIcons />
    </div>
  );
}

export default App;
